import React, { Component } from 'react';

class LandingAd extends Component {
    render() {
        return (
            <div className="showtix-section">
                {this.props.event.ad_graphic_url &&
                <div className="row">
                    <div className="col-12 showtix-event__advertisement">
                        <img src={this.props.event.ad_graphic_url} alt="Advertisement" />
                    </div>
                </div>
                }
            </div>
        );
    }
}

LandingAd.propTypes = {
    
}

export default LandingAd;


// WEBPACK FOOTER //
// ./src/components/EventLanding/LandingAd/LandingAd.js